
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.11 8.7a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8zM7.71 8.7a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8zM13.31 8.7a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8z","fill":"currentColor"}})])
          )
        }
      }
    